import __request__ from "routing/request";
export function create(SearchfilterinJSONformat, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.searchfilters/search_filters", SearchfilterinJSONformat, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.searchfilters/search_filters", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, scope = "ALL", order = "asc", only_mutable = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.searchfilters/search_filters/paginated", null, { "page": page, "per_page": per_page, "query": query, "scope": scope, "sort": sort, "order": order, "only_mutable": only_mutable }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(filterId, SearchfilterinJSONformat, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.searchfilters/search_filters/${filterId}`, SearchfilterinJSONformat, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(filterId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.searchfilters/search_filters/${filterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(filterId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.searchfilters/search_filters/${filterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
